import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import Logo from '../../public/static/images/brown-logo.svg';
import Plus from '../../public/static/images/green-plus.svg';
import CloseWebview from '../../public/static/images/close-webview.svg';
import {
  setChosenLocationNames,
  setCurrentState,
  setLocationIds,
  switchTab,
  togglePromotionModalView
} from '../../actions';
import { useBridgeAPI, useBridgeState } from '../../bridge';

const WhiteHeader = ({ headerTitle = '' }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { isWebView } = useBridgeState();
  const { closeWebview } = useBridgeAPI();
  const headerClassNames = classNames('white-header', 'white-header--fixed', {
    'white-header--main': !headerTitle
  });

  const clickHandle = () => {
    dispatch(switchTab(0));
    dispatch(setChosenLocationNames([]));
    dispatch(setLocationIds([]));
    dispatch(setCurrentState(null));
    dispatch(togglePromotionModalView(false));

    return router.push('/');
  };

  return (
    <div className={headerClassNames} id="white-header">
      {headerTitle ? (
        <span className="white-header__title">{headerTitle}</span>
      ) : (
        <>
          <a
            className="white-header__logo"
            data-cy="white-header-logo"
            data-stat="header-logo"
            onClick={clickHandle}
            onKeyPress={clickHandle}
            role="button"
            tabIndex="-1"
          >
            <Icon IconComponent={Logo} width={85} height={19} />
          </a>
          {isWebView ? (
            <button
              className="white-header__webview-btn"
              onClick={closeWebview}
            >
              <Icon
                IconComponent={CloseWebview}
                width={30}
                height={30}
                indent={false}
                color={'#a9a39e'}
              />
            </button>
          ) : (
            <a
              className="white-header__new-btn"
              href="/items/new"
              data-stat="header-new-btn"
            >
              <Icon
                IconComponent={Plus}
                width={30}
                height={30}
                indent={false}
              />
            </a>
          )}
        </>
      )}
    </div>
  );
};

WhiteHeader.propTypes = {
  headerTitle: PropTypes.string
};

export default WhiteHeader;
